<ex-app-menu-panel [isOpen]="isOpen" desktopMode="mobile-only" (close)="close.emit()">

  <div class="profile-menu__header">
    <span class="profile-menu__username" i18n="@@nav.hello">Bonjour {{ profile()?.firstname }}</span>
    @if(currentPet()) {
      <span class="profile-menu__pet" [routerLink]="['board', 'pets',currentPet()?.id, 'edit']">
        <span i18n="@@auth.logged-with">Logged with</span> {{ currentPet()?.pseudo }}
      </span>
    }
  </div>

  <nav class="profile-menu__nav">
    <a routerLink="/dashboard" routerLinkActive="active" i18n="@@header.navbar.dashboard">Fil d'actualité</a>
    <a routerLink="/board/pets" routerLinkActive="active" i18n="@@board.menu.pets">Mes animaux</a>
  </nav>
<!-- 
  <hr class="profile-menu__divider">

  <nav class="profile-menu__nav">
    <a routerLink="/members" routerLinkActive="active" i18n="@@board.menu.members">Membres</a>
    <a routerLink="/teams" routerLinkActive="active" i18n="@@board.menu.all-teams">Teams</a>
  </nav> -->

  <hr class="profile-menu__divider">

  <nav class="profile-menu__nav profile-menu__nav--secondary">
    <a [routerLink]="'/board/edit-user'" routerLinkActive="active" i18n="@@board.menu.user-edit">Edit my account</a>
    <a [routerLink]="'/board/edit-pet'" routerLinkActive="active" i18n="@@board.menu.pet-edit">Edit my pet</a>
    <a [routerLink]="'/board/edit-password'" routerLinkActive="active" i18n="@@board.menu.user-password">Edit password</a>
    <a class="profile-menu__logout" (click)="logout()" i18n="@@board.menu.logout">Disconnect</a>
  </nav>

</ex-app-menu-panel>
